import axios from 'axios';
import { API_BASE_URL } from '../config';

export const getEventActually = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}events/`);

        // Comprobamos si la respuesta fue exitosa
        if (response.status === 200) {
            const events = response.data; // Suponiendo que `response.data` contiene el array de eventos

            // Desestructuramos el primer evento (si existe)
            if (events.length > 0) {
                const { speakers } = events[0];

                // Desestructuramos los hablantes
                const speakerDetails = speakers.map(({ name, profession, picture, picture_description, description, country_id}) => ({
                    name,
                    profession,
                    picture,
                    picture_description,
                    flag: country_id?.flag,
                    description
                }));

                return {
                    events,
                    speakers: speakerDetails
                };
            }
        }
    } catch (error) {
        console.error('Error fetching event:', error);
        // Maneja el error según tus necesidades
    }

    return null; // Retorna null si no se encuentra el evento
}
 
const RegisterUserEvent = async (token, userEvent) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.post(`${API_BASE_URL}register-user-event/`, 
        userEvent, 
        {
            headers: {
                Authorization: `Bearer ${token}`, // Aquí asegúrate que el token esté formateado correctamente
            },
        });
        return response; // Devuelve la respuesta completa
    } catch (error) {
        if (error.response) {
            throw error.response; // Lanza la respuesta completa en caso de error
        } else {
            throw error; // Lanza el error completo si no hay respuesta
        }
    }
}

export default RegisterUserEvent;
